module.exports = __webpack_public_path__ + "img/sun_set.1ab5e2e2.jpg";